<script>
export default {
    name: "ContentModal",
    props: {
        // canUserClose
        // sets if user can close this modal.
        canUserClose: {
            type: Boolean,
            default: true,
        },
        // give the modal a name so we can control it outside of the
        // component via the root Vue Instance/Event bus. Lets us extend
        // modal functionality in this wrapping component
        name: {
            type: String,
            default: "ContentModalName"
        },
        // showOnLoad
        // determine if modal should immediately be shown on load
        showOnLoad: {
            type: Boolean,
            default: false
        },
    },
    data () {
        return {
            visible: this.showOnLoad
        }
    },
    created () {
        // listen for root element's emits
        // TODO when various in-page controls become Vue Components, may change
        this.$root.$on( "request:modal", this.showOnRequest )
    },
    methods: {
        setBody () {
            // setBody
            // locks or unlocks body scroll; interactions are with modal
            const bodyStyle = document.getElementsByTagName( "body" )[0].style

            // safeguarding for modal inclusion
            bodyStyle.width = "100%"
            bodyStyle.overflow = ( this.visible ) ? "hidden" : ""
        },

        // showOnRequest
        // call optical control function on event if this modal is requested
        // keeps created() clean
        showOnRequest ({ name }) {
            if ( name === this.name ) this.showSelf( true )
        },

        // showSelf
        // change display status of modal, inform parent of active state
        // can act as a toggle if called on its own
        showSelf ( status = !this.visible ) {
            // don't close if user is not allowed to close the modal
            if ( status || this.canUserClose ) {
                this.visible = status
                this.$emit( "relay:active", { active: this.visible })
                this.setBody()

                if ( !this.visible ) {
                    this.$emit( "close-modal" )
                }
            }
            else {
                this.$emit( "cancel-close" )
            }
        },
    }
}
</script>

<template>
<!--
    modal wrapper, sets up backdrop
    clicking the backdrop outside of the modal will close the modal
-->
<div
    class="butter-modal"
    v-if="visible"
    @click.self="showSelf(false)"
>
    <aside class="butter-modal-element">
        <div class="butter-modal-body">
            <!-- modal body slot: lets us drop in other content -->
            <slot></slot>
        </div>

        <footer class="butter-modal-footer">
            <!-- modal close control: just close the modal -->
            <button
                class="butter-modal-ctrl--close"
                v-if="canUserClose"
                @click="showSelf(false)"
            >
                <fa-icon icon="close"></fa-icon>
                <span class="ctrl-label--a11y">Close</span>
            </button>
        </footer>
    </aside>
</div>
</template>
